'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var fontStyles = {
  capitalize: function capitalize() {
    return 'text-transform: capitalize;';
  },
  italicize: function italicize() {
    return 'font-style: italic;';
  },
  lowercase: function lowercase() {
    return 'text-transform: lowercase;';
  },
  underline: function underline() {
    return 'text-decoration: underline;';
  },
  uppercase: function uppercase() {
    return 'text-transform: uppercase;';
  }
};

exports.default = fontStyles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/modifiers/fontStyles.js
// module id = 1521
// module chunks = 2